import {
  individualStoreProfileConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { individualStoreProfileService } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";

const { BRAND_ID, LOCATION_ID, FETCH_GENERAL_DATA, RESET_STORE_PROFILE } =
  individualStoreProfileConstants;

//Getting the general data like name , owner's name etc for a specific location
const getStoreProfileData = (id, fromFR) => {
  return (dispatch) => {
    return withSpinner(dispatch, FETCH_GENERAL_DATA, () =>
      individualStoreProfileService
        .getStoreProfileData(id, fromFR)
        .then(
          (response) => {
            dispatch(success(response, FETCH_GENERAL_DATA));
            return response;
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//Storing location id in reducer for its usage in further calls
const locationId = (id) => {
  return (dispatch) => {
    dispatch(success(id, LOCATION_ID));
  };
};

//Storing brand id in reducer for its usage in further calls
const getBrandId = (brandId) => {
  return (dispatch) => {
    dispatch(success(brandId, BRAND_ID));
  };
};

//Empty store profile
const resetRestaurantProfile = () => (dispatch) =>
  dispatch(success({}, RESET_STORE_PROFILE));

// exporting functions for other files
export const individualStoreProfileActions = {
  getStoreProfileData,
  locationId,
  getBrandId,
  resetRestaurantProfile,
};
